var render = function render() {
      var _vm = this,
          _c = _vm._self._c,
          _setup = _vm._self._setupProxy;return _vm.showBalanceAlert ? _c('el-alert', { staticClass: "pt-custom-alert", staticStyle: { "margin-bottom": "16px" }, attrs: { "title": _vm.$t('playTurbo.common.balanceThresholdTips', {
                        balance_threshold: _vm.balanceThreshold
                  }), "type": "warning", "show-icon": "" } }) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };